import { theme } from 'Assets/Styles/theme'
import brandTheme from 'Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const styles = {
  wrapper: {
    position: 'relative',
    padding: '40px 60px 80px',
  },
  step: {
    position: 'relative',
    height: 2,
    background: theme.colors.iron,
    float: 'left',
    marginBottom: 60,

    '&.done': {
      textDecoration: 'line-through',
      borderTop: `2px solid ${colors.primary}`,
      '& $marker': {
        background: colors.primary,
      },
      '& $title': {
        color: colors.primary,
      },
    },

    '&.edit': {
      cursor: 'pointer',
    },
  },
  marker: {
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translate(50%, -50%)',
    width: 15,
    height: 15,
    background: theme.colors.iron,
    borderRadius: '50%',
    zIndex: 1,
    '&:first-child': {
      transform: 'translate(100%, -50%)',
    },
  },
  title: {
    position: 'absolute',
    color: theme.colors.regentGray,
    top: 15,
    right: 0,
    transform: 'translateX(50%)',
    textAlign: 'center',
    maxWidth: 80,
  },
}



// WEBPACK FOOTER //
// ./src/Components/TimeLine/styles.js